<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="860px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @opened="opened"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="位置" :label-width="formLabelWidth" prop="infoType">
        <el-select v-model="editForm.infoType" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="隐私条例名称"
        :label-width="formLabelWidth"
        prop="name"
      >
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="隐私条例内容"
        :label-width="formLabelWidth"
        prop="answer_analyze"
      >
        <div id="newEditor"></div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import E from 'wangeditor';
import { formData, formRules } from '../form.js';
import {
  privacyAdd,
  privacyEdit,
  privacyUpload,
  privacyGetContent,
} from '@/api/privacyPolicy.js';
// privacyGetContent,
//
export default {
  name: 'editPolicy',
  components: {},
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      privacyId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      editData: {},
      editForm: { ...formData }, // 编辑表单
      editRules: formRules, // 表单的验证规则,
      actionUrl: '',
      editor: null,
      typeList: [
        {
          id: 1,
          label: '注册',
        },
        {
          id: 2,
          label: '个人信息',
        },
        {
          id: 3,
          label: '推荐',
        },
        {
          id: 4,
          label: '邀请注册',
        },
        {
          id: 5,
          label: '推荐物业服务',
        },
        {
          id: 6,
          label: '酒店宴会推荐',
        },
      ],
      type: 'edit',
      //   defaultContent: null, // 富文本
    };
  },
  inject: ['reload'],
  mounted() {},
  methods: {
    resetFrom() {
      this.editForm = { ...formData };
      // 销毁编辑器
      if (!this.editor) return;
      this.editor.destroy();
      this.editor = null;

      this.$refs.editForm.clearValidate(); // 清除验证
    },
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          // 获取编辑后的html
          this.editForm.content = this.editor.txt.html();
          if (!this.editForm.content) {
            return this.$message.warning('请先补充隐私条例内容');
          }

          if (this.editForm.id != '') {
            await privacyEdit(this.editForm.id, {
              id: this.editForm.id,
              content: this.editForm.content,
              name: this.editForm.name,
              infoType: this.editForm.infoType,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');
              } else {
                this.$message.error('编辑失败!');
                return;
              }
            });
          } else {
            await privacyAdd({ ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('新增成功!');
              } else {
                this.$message.error('新增失败!');
                return;
              }
            });
          }
          this.dialogFormVisible = false;
          this.editForm = {};
          // 重新获取数据
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        privacyUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            _this.editForm.headImg = res.data.absoluteFileUrl;
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },
    init() {
      // if (this.editData != null) {
      // this.editForm.name = this.editData.name;
      // }
    },
    async getContent() {
      await privacyGetContent(this.editForm.id).then((res) => {
        const content = res && res.data ? res.data.content : '';
        // const content = this.editForm.content;
        this.editor = new E('#newEditor');
        this.editor.config.uploadImgMaxSize = '5 * 1024 * 1024'; //控制图片大小
        this.editor.config.uploadFileName = 'file'; // 上传参数
        this.editor.config.showLinkImg = false; // 隐藏插入网络图片的功能
        this.editor.config.uploadImgServer = `${window.RequestUrl}/upload/images/photo`; //上传图片
        this.editor.create();

        // 上传图片 insertImgFn
        this.editor.config.uploadImgHooks = {
          // 上传图片之前
          before(xhr) {
            console.log(xhr);

            // 可阻止图片上传
            return {
              prevent: false, // 是否阻止上传
              msg: '需要提示给用户的错误信息',
            };
          },
          // 图片上传并返回了结果，图片插入已成功
          success(xhr) {
            console.log('success', xhr);
          },
          // 图片上传并返回了结果，但图片插入时出错了
          fail(xhr, editor, resData) {
            console.log('fail', resData);
          },
          // 上传图片出错，一般为 http 请求的错误
          error(xhr, editor, resData) {
            console.log('error', xhr, resData);
          },
          // 上传图片超时
          timeout(xhr) {
            console.log('timeout', xhr);
          },
          // 图片上传并返回了结果，想要自己把图片插入到编辑器中
          // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
          customInsert(insertImgFn, result) {
            // result 即服务端返回的接口
            console.log('customInsert', result);
            if (result.code == 200) {
              // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
              insertImgFn(result.data);
            } else {
              this.$message.error('服务器出错');
            }
          },
        };
        this.editor.txt.append(content);
      });
    },
    opened() {
      this.init();
      this.getContent();
    },
    beforeDestroy() {
      // 销毁编辑器
      this.editor.destroy();
      this.editor = null;
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  min-height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 200px;
  display: block;
}

.toolbar {
  border: 1px solid #ccc;
  width: 100%;
}

.el-form-item {
  /* margin-bottom: 5px; */
}

.el-dialog__header {
  height: 30px;
}
</style>
